import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'usb-item-rentacar-sidebar',
  templateUrl: './item-rentacar.component.html',
  styleUrls: ['./item-rentacar.component.scss']
})
export class UsbItemRentacarComponent implements OnInit {

  @Input() item: any;
  @Input() styleSidebar: any;
  @Input() currencyAgency: any;
  @Input() currencies: any;

  constructor() { }

  ngOnInit() {
    console.log(this.item);
  }

  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stringUpperCase(str){
    let e = str.toLowerCase()
    return e.replace(/\b\w/g, l => l.toUpperCase())
  }

}
